<template>
  <div class ="ml-7">
        <v-row>
        <v-col
          class ="ml-5"
          cols="6"
          md="6"
        >
          <GraphBar type="chart"/>
        </v-col>
        <v-col
          class ="ml-6"
          cols="5"
          md="5"
        >
          <GraphLine type="chart"/>
        </v-col>
        </v-row>
  </div> 
</template>

<script>
import GraphBar from '@/components/GraphBar'
import GraphLine from '@/components/GraphLine'

export default {
  name: 'MetroRegionalChart',
  props: {
  },  
  components: {GraphBar, GraphLine },
  
  data () {
    let overlay = false 
    return {
      overlay
    }
  },
  methods: {
  },
  watch: {
    /*
    '$route' () {
    },
    */
  },   
  mounted () {
  }  
}
</script>
